import axiosSetup from "../utils/axiosSetup";
import { WarrantyDetails } from "../models/warrantlyDetails.model";

export const fetchWarrantyDetailsApi = async ({
  page = 1,
  limit = 10,
  search = "",
  startDate,
  endDate,
  dateFilterType,
  epcId
}: {
  page?: number;
  limit?: number;
  search?: string;
  startDate?: string;
  endDate?: string;
  dateFilterType?: string;
  epcId?: string;
}): Promise<{
  data: WarrantyDetails[];
  totalItems: number;
  totalRecords: number;
  totalPages: number;
}> => {
  try {
    const res = await axiosSetup.get("/products/warranty-details", {
      params: { page, limit, search, startDate, endDate, dateFilterType, epcId },
    });
    return {
      data: res.data.data.data || [],
      totalItems: res.data.data.totalItems || 0,
      totalRecords: res.data.data.totalRecords || 0,
      totalPages: res.data.data.totalPages || 0,
    };
  } catch (error) {
    throw error;
  }
};

export const updateWarrantyDetailsApi = async (
  id: string,
  data: Partial<WarrantyDetails>
): Promise<WarrantyDetails> => {
  try {
    const res = await axiosSetup.put(`/products/warranty-details/update/${id}`, data);
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const downloadWarrantyPdfApi = async (payload: { id: string }) => {
  try {
    const res = await axiosSetup.post("/products/warranty/download", payload, {
      responseType: "blob",
    });
    return res;
  } catch (error) {
    throw error;
  }
};